import React, { useMemo, useEffect, useState } from 'react'
import moment from 'moment-jalaali'
import { makeStyles } from '@material-ui/core'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import PropTypes from 'prop-types'
import Badge from '@material-ui/core/Badge'
import Page from 'src/components/Page'
import { useDispatch, useSelector } from 'react-redux'
import { getNotifications, seenNotifications, getUnseenNumber } from '../../app/slices/notificationSlice'

const useStyle = makeStyles(() => ({
  root: {
    padding: 10,
  },
  card: {
    width: '100%',
  },
  badge: {
    width: '100%',
  },
  badgeItem: {
    top: 5,
    right: 10,
    width: 'fit-content',
  },
  header: {
    marginBottom: 15,
  },
  titles: {
    fontWeight: 700,
  },
  notifType: {
    fontSize: '0.7rem',
    opacity: 0.6,
  },
  buttonContainer: {
    margin: '0px !important',
    padding: 10,
  },
}))

const NotificationContainer = ({ data = {} }) => {
  const classes = useStyle()
  const faDate = useMemo(() => moment(data.createDate)?.format('jYYYY/jMM/jDD'), [data])
  return (
    <Grid container className={classes.root}>
      <Badge classes={{ badge: classes.badgeItem, root: classes.badge }} color="secondary" overlap="circle" badgeContent={!data.isSeen ? 'جدید' : null}>
        <Card className={classes.card}>
          <CardContent>
            <Grid className={classes.header} container justify="space-between">
              <Typography className={classes.titles} variant="h5" component="h5">
                {data.title}
                {' '}
                <span className={classes.notifType}>{data.isPersonal ? '(شخصی)' : '(عمومی)' }</span>
              </Typography>
              <Typography>
                {faDate}
              </Typography>
            </Grid>
            <Grid>
              <Typography>{data.content}</Typography>
            </Grid>
          </CardContent>
        </Card>
      </Badge>
    </Grid>
  )
}

NotificationContainer.propTypes = {
  data: PropTypes.object,
}

export const User = () => {
  const classes = useStyle()
  const defaultRowPerPage = 10
  const dispatch = useDispatch()
  const notifications = useSelector((state) => state.notifications.list || [])
  const count = useSelector((state) => state.notifications.totalHits)
  const [rowPerPage, setRowPerPage] = useState(defaultRowPerPage)

  useEffect(() => {
    dispatch(getNotifications({
      first: rowPerPage,
      after: 0,
    }))
    dispatch(getUnseenNumber())
  }, [rowPerPage])

  const sortedList = useMemo(() => {
    if (notifications?.length > 0) {
      const list = [...notifications]
      return list?.sort((a, b) => (
        new Date(b?.createDate).getTime() - new Date(a?.createDate).getTime()
      ))
    }
    return []
  },
  [notifications])

  useEffect(() => {
    if (notifications?.length > 0) {
      const seenList = notifications?.filter(
        (item) => !item.isSeen,
      )?.map((item) => item.notificationId)
      if (seenList.length > 0) {
        dispatch(seenNotifications(seenList))
        setTimeout(() => {
          dispatch(getNotifications({
            first: rowPerPage,
            after: 0,
          }))
        }, 2000)
      }
    }
  }, [notifications])

  return (
    <Page className={classes.root} title="اعلانیه">
      {sortedList.map((data) => (
        <NotificationContainer key={data.notificationId} data={data} />
      ))}
      <Grid container justify="center">
        <Button disabled={sortedList.length >= count} variant="contained" color="primary" onClick={() => setRowPerPage(rowPerPage + defaultRowPerPage)}> مشاهده بیشتر</Button>
      </Grid>
    </Page>
  )
}

export default User
